<template>
  <PageHeroAboutStyle
    :title="categoryTitle"
    :subtitle="categorySubtitle"
    :show-overlay="false"
    text-variant="dark"
    :background-image="categoryData.backgroundImage"
    :background-image-mobile="categoryData.backgroundImageMobile"
    :background-position-y="categoryData.backgroundPositionY"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  COURSE_CATEGORY_HERO_META,
  DEFAULT_COURSE_CATEGORY_HERO,
  type CourseCategoryHeroMeta
} from '@/constants/course-category-hero'

interface CategoryData extends CourseCategoryHeroMeta {
  title: string
  subtitle: string
}

interface Props {
  category?: string
}

const props = withDefaults(defineProps<Props>(), {
  category: DEFAULT_COURSE_CATEGORY_HERO
})

const { t } = useI18n()

const categoryData = computed((): CategoryData => {
  const key = props.category && props.category in COURSE_CATEGORY_HERO_META ? props.category : DEFAULT_COURSE_CATEGORY_HERO
  const meta = COURSE_CATEGORY_HERO_META[key] ?? COURSE_CATEGORY_HERO_META[DEFAULT_COURSE_CATEGORY_HERO]
  const heroKey = key as keyof typeof COURSE_CATEGORY_HERO_META
  return {
    ...meta,
    title: t(`courseCategory.hero.${heroKey}.title`),
    subtitle: t(`courseCategory.hero.${heroKey}.subtitle`)
  } as CategoryData
})

const categoryTitle = computed(() => {
  const data = categoryData.value
  const raw = data?.title ?? t('courseCategory.hero.defaultTitle')
  if (!raw || typeof raw !== 'string') return raw
  return raw.charAt(0).toUpperCase() + raw.slice(1)
})

const categorySubtitle = computed(() => {
  const data = categoryData.value
  return data?.subtitle ?? t('courseCategory.hero.defaultSubtitle')
})
</script>
